enum JobWorkerInterviewType {
	Undefined = 0,
	Telephone = 1,
	Online = 5,
	InPerson = 10
}

export default JobWorkerInterviewType;